import ArrowRightIcon from "@svg/player/arrow-right";
import CircleAnimateIcon from "@svg/player/circle";
import { toFarsiNumber } from "@utils/digits";
import { useEffect, useRef } from "react";
import XMark from "@svg/x-mark";

interface Props {
  onGoNext: (autoplay?: boolean) => void;
  onClose: () => void;
  nextName: string;
}

const NextTimer: React.FC<Props> = ({ onClose, onGoNext, nextName }) => {
  const spanRef = useRef<HTMLSpanElement | null>(null);

  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const updateSpanText = (
    spanElement: HTMLSpanElement | null,
    time: number
  ) => {
    if (spanElement) spanElement.textContent = toFarsiNumber(time);
  };

  useEffect(() => {
    let time = 5;

    const spanElement = spanRef.current;
    updateSpanText(spanElement, time);

    if (!intervalRef) return;

    intervalRef.current = setInterval(() => {
      time--;

      if (time > 0) {
        updateSpanText(spanElement, time);
      } else {
        onGoNext(true);
        if (intervalRef?.current) clearInterval(intervalRef.current);
      }
    }, 1000);

    return () => {
      if (intervalRef?.current) clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{ direction: "rtl" }}
      className="bg-black/80 absolute inset-0 z-0  cursor-default flex flex-col  "
    >
      <div className="mb-3.5 flex flex-col  h-full overflow-hidden justify-center items-center ">
        <div className="relative">
          <CircleAnimateIcon />
          <div className="absolute inset-0 flex justify-center items-center text-white">
            <span
              ref={spanRef}
              className="text-base leading-none font-medium"
            ></span>
          </div>
        </div>

        <h3 className="text-white font-medium text-[18px] leading-6 mt-4">
          {nextName}
        </h3>
        <button
          onClick={() => onGoNext(true)}
          className="mt-2 flex items-center text-fds-on-inverse active:opacity-80"
        >
          <ArrowRightIcon />
          <span className="mr-2 text-sm text-fds-on-inverse">درس بعدی</span>
        </button>
      </div>
      <div className="absolute top-4 right-1.5 md:top-6 md:right-3.5 lg:top-8 lg:right-5">
        <button
          onClick={onClose}
          className="flex items-cente text-fds-on-inverse  bg-red-200"
        >
          <XMark />
          <span className="text-sm mr-2 text-fds-on-inverse ">انصراف</span>
        </button>
      </div>
    </div>
  );
};

export default NextTimer;
